import React from "react"
import { Link } from "gatsby-plugin-react-i18next"

import GrandPrix from "../../../images/contents/story-contest-grand-prix.svg"
import Winning from "../../../images/contents/story-contest-winning.svg"
import classes from "./StoryContestWork.module.scss"

type Props = {
  data: {
    title: string
    author: string
    award?: "grandPrix" | "grandPrixCandidate" | "winning"
  }
}

const StoryContestWork: React.FC<Props> = ({ data }) => {
  const URL = data.award
    ? "/result/2021/story_contest/"
    : "/event/story_contest/"
  return (
    <div className={classes.StoryContestWork}>
      {data.award === "grandPrix" ? (
        <GrandPrix className={classes.awardLogo} />
      ) : null}
      {data.award === "grandPrixCandidate" ? (
        <div className={classes.LogoContainer}>
          <Winning className={classes.awardLogo} />
          <p className={classes.GrandPrixCandidate}>大賞候補作品</p>
        </div>
      ) : null}
      {data.award === "winning" ? (
        <Winning className={classes.awardLogo} />
      ) : null}
      <p className={classes.Title}>{data.title}</p>
      <p className={classes.Author}>{data.author}</p>
      <Link to={URL + data.title}>作品を読む</Link>
    </div>
  )
}

export default StoryContestWork
